var _path, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedCloseFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancel-close",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 0.833344C4.931 0.833344 0.833496 4.93084 0.833496 10C0.833496 15.0692 4.931 19.1667 10.0002 19.1667C15.0693 19.1667 19.1668 15.0692 19.1668 10C19.1668 4.93084 15.0693 0.833344 10.0002 0.833344ZM13.9418 13.9417C13.5843 14.2992 13.0068 14.2992 12.6493 13.9417L10.0002 11.2925L7.351 13.9417C6.9935 14.2992 6.416 14.2992 6.0585 13.9417C5.701 13.5842 5.701 13.0067 6.0585 12.6492L8.70766 10L6.0585 7.35084C5.701 6.99334 5.701 6.41584 6.0585 6.05834C6.416 5.70084 6.9935 5.70084 7.351 6.05834L10.0002 8.70751L12.6493 6.05834C13.0068 5.70084 13.5843 5.70084 13.9418 6.05834C14.2993 6.41584 14.2993 6.99334 13.9418 7.35084L11.2927 10L13.9418 12.6492C14.2902 12.9975 14.2902 13.5842 13.9418 13.9417Z",
    fill: "#04B7EF"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#cancel-close {\n    cursor: pointer;\n}\n#cancel-close {\n    transition: fill 0.5s ease;\n}\n#cancel-close:hover path {\n    fill: #04A5D8;\n}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedCloseFilledIcon);
export default __webpack_public_path__ + "static/media/DeprecatedCloseFilledIcon.3f55ceca6ab553314b5802309a6146f2.svg";
export { ForwardRef as ReactComponent };